import React from 'react';  
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Home from './components/Home';
import Services from './components/Services';
import Work from './components/Work';
import About from './components/About';
import Blog from './components/Blog';
import Contact from './components/Contact';
import Footer from './components/Footer';

// Service detail components
import WebDesignDevelopment from './components/services/WebDesignDevelopment';
import SEO from './components/services/SEO';
import VisualBranding from './components/services/VisualBranding';
import ConsultationAudit from './components/services/ConsultationAudit';
import UIUX from './components/services/UIUX';
import WhatWeUse from './components/services/whatweuse';

function App() {
  return (
    <Router>
      {/* Updated background to Aqua Haze (#F0F4F8) and text to River Bed (#4A5568) per brand guidelines */}
      <div className="font-sans antialiased bg-[#F0F4F8] text-[#4A5568] min-h-screen flex flex-col">
        <Header />
        
        {/* PADDING FIX: 
            pt-28 (112px) for mobile 
            md:pt-36 (144px) for desktop 
            This ensures content starts below your fixed header.
        */}
        <main className="flex-grow pt-28 md:pt-36">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/home" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/services/web-design-development" element={<WebDesignDevelopment />} />
            <Route path="/services/seo" element={<SEO />} />
            <Route path="/services/visual-branding" element={<VisualBranding />} />
            <Route path="/services/consultation-audit" element={<ConsultationAudit />} />
            <Route path="/services/ui-ux" element={<UIUX />} />
            <Route path="/services/what-we-use" element={<WhatWeUse />} />
            <Route path="/work" element={<Work />} />
            <Route path="/about" element={<About />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>

        <Footer />
      </div>
    </Router>
  );
}

export default App;